module.exports = __webpack_public_path__ + "img/full7-min.333e0cb2.png";